<template>
  <path
    fill="currentColor"
    d="M9 21.5L17.5 13L13 10L15 2.5L6.5 11L11 14L9 21.5Z"
  />
</template>
